<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                title="Re-order Level Report"
                btnTitle="Add new"
                :showBtn="false"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                :isHideDate="true"
                :isVisible="false"
            >
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mr-top-1">
                    <label class="form-label">Manufacturer</label>
                    <v-select
                        placeholder="Select manufacturer"
                        label="name"
                        :options="manufacturers"
                        v-model="manufacturer"
                        :reduce="text => text.value"
                    />
                </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">

                <div class="d-flex align-items-center justify-content-between filter-label">
                  <label for="colFormLabel" class="col-form-label">Supplier: </label>
                  <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                      <i class="fas fa-search"></i>
                  </span>
                </div>

                <AsyncSelect
                    placeholder="Select Supplier"
                    v-model="contactProfile"
                    :api-service="fetchContactProfiles"
                    :additional-query="additionalContactOption"
                />
              </div>
              <div class="col-md-3 my-auto">
                <div class="d-flex gap-1 justify-content-between mt-2">
                  <button class="btn btn-primary btn-block waves-effect waves-float waves-light" @click="onClickGo">
                    Submit
                  </button>
                  <button @click="exportTable"
                          class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect">
                    Export
                  </button>
                </div>
              </div>
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
            <ListTable
                :tableItems="tableItems"
            />
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>
      <ContactDropdownFilter
          v-if="store.state.isModalOpenThree"
          @onSearchContact="onSearchContact"
          type="customer"
      />
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {computed, inject, onMounted, reactive, ref, watch} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import ListTable from '@/components/molecule/company/hospital/pharmacy/ReorderReportTable.vue';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHospital from '@/services/modules/hospital'
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import handleContact from "@/services/modules/contact";

const token = computed(() => localStorage.getItem('token'));
const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = reactive({
    searchTxt: '',
    offset: 10
});

let contactProfile = ref(null)
const manufacturers = ref([]);
const manufacturer = ref(null);

const additionalContactOption = ref({
  roles: 'supplier'
});

const { fetchReorderReport, fetchManufacturer } = handleHospital();
const {fetchContactProfiles} = handleContact();


const onOpenContactSearchModal = () => {
  store.state.isModalOpenThree = true;
}

const onSearchContact = (contact) => {
  contactProfile.value = contact
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

async function onPageChange(page) {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getReorderReport();
}

const onClickGo = () => {
    getReorderReport()
}

const exportTable = () => {
  let url = `${process.env.VUE_APP_BASE_URL}/export/hospital/pharmacy/reorder-reports` + getQuery() + `&_token=${token.value}`;
  let a = document.createElement("a")
  a.setAttribute("href", url)
  a.click()
}

const getReorderReport = async () => {
    const query = getQuery();
    loading.value = true

    await fetchReorderReport(query).then(res => {
        loading.value = false
        if (!res.status){
            store.commit("resetPagination")
            return
        }
        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getManufacturers = async () => {
    await fetchManufacturer(getQuery()).then(res => {
        if (!res.status) return
        manufacturers.value = res.data
    }).catch(err => {
        console.log(err)
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page
    if(params.searchTxt) query += `&search_txt=${params.searchTxt}`;
    if(manufacturer.value) query += `&manufacturer=${manufacturer.value}`;
    if(contactProfile.value) query += `&contact_profile_id=${contactProfile.value.id}`;
    query += '&offset=' + params.offset
    return query;
}

onMounted(async () => {
    await getManufacturers();
    await getReorderReport();
})
</script>

<style scoped>
.mr-top-1 {
    margin-top: 1% !important;
}
</style>
